const SITE_URL = "https://www.institut-taxi.fr";
const SERVICES_PATH = "/formations-taxi-vtc";

const provider = {
  "@type": "Organization",
  name: "Institut Taxi",
  url: SITE_URL,
};

const itemIdToSection = {
  "formation-taxi": "taxi",
  "formation-vtc": "vtc",
  "formations-acceleree-vtc-taxi": "modulables",
  "carte-pro-vtc-taxi": "mobilite",
};

const sections = {
  default: {
    itemId: null,
    slug: null,
    title: "Formations taxi, VTC, modulables et mobilité | Institut Taxi",
    description:
      "Découvrez les formations taxi, VTC, modulables et mobilité de l'Institut Taxi. Comparez les rythmes, les prix, l'accompagnement, les solutions CPF et les liens de détail selon votre objectif.",
  },
  taxi: {
    itemId: "formation-taxi",
    slug: "taxi",
    title: "Formation taxi: initiale, continue et pratique | Institut Taxi",
    description:
      "Consultez les formations taxi de l'Institut Taxi: initiale, continue, pratique, e-learning, passerelles taxi VTC et mobilité 92/75, avec prix et détail des parcours.",
    listName: "Tarifs des formations taxi",
    serviceType: "Formation taxi",
    offers: [
      {
        name: "Formation taxi initiale journée",
        route: "/formation-taxi-initiale",
        price: "1350",
        fee: "+237€ frais examen CMA",
        meta: [
          { label: "Durée", value: "3 semaines" },
          { label: "Rythme", value: "Lundi au vendredi" },
          { label: "Horaires", value: "9h30 / 16h30" },
        ],
        highlights: [
          "Éligible CPF",
          "Paiement en 3x sans frais",
          "3 séances de conduite",
          "Véhicule mis à disposition le jour de l'examen",
        ],
      },
      {
        name: "Formation taxi initiale soir",
        route: "/formation-taxi-initiale",
        price: "1350",
        fee: "+237€ frais examen CMA",
        meta: [
          { label: "Durée", value: "2 semaines" },
          { label: "Rythme", value: "Lundi au vendredi" },
          { label: "Horaires", value: "18h / 22h" },
        ],
        highlights: [
          "Examen blanc inclus",
          "Éligible CPF",
          "Paiement en 3x sans frais",
          "3 séances de conduite",
          "Véhicule mis à disposition le jour de l'examen",
        ],
      },
      {
        name: "Formation taxi initiale week-end",
        route: "/formation-taxi-initiale",
        price: "1350",
        fee: "+237€ frais examen CMA",
        meta: [
          { label: "Durée", value: "4 week-ends" },
          { label: "Rythme", value: "Samedi et dimanche" },
          { label: "Horaires", value: "9h30 / 16h30" },
        ],
        highlights: [
          "Examen blanc inclus",
          "Éligible CPF",
          "Paiement en 3x sans frais",
          "3 séances de conduite",
          "Véhicule mis à disposition le jour de l'examen",
        ],
      },
      {
        name: "Formation Taxi E-learning",
        route: "/formation-taxi-en-ligne",
        price: "549",
        fee: "Frais d'examen inclus",
        meta: [
          { label: "Durée", value: "1 mois" },
          { label: "Support", value: "Application ludo-pédagogique" },
          { label: "Questions", value: "Entre 1 000 et 1 500" },
        ],
        highlights: [
          "Paiement en 4 fois sans frais de 137,25€",
          "QCM, jeux, duels, etc.",
          "Théorie et pratique avec véhicule",
          "Examen blanc inclus",
        ],
      },
      {
        name: "Formation taxi continue 14h",
        route: "/formation-taxi-continue",
        price: "229",
        meta: [
          { label: "Volume", value: "14h / 2 jours" },
          { label: "Planning", value: "Disponibilité à convenir" },
        ],
        note: "Cette formation continue est obligatoire pour les chauffeurs déjà titulaires de la carte professionnelle taxi. Elle se suit tous les 5 ans pour mettre à jour réglementation, sécurité routière et gestion.",
      },
      {
        name: "Formation taxi pratique seule",
        route: "/formation-taxi-pratique-seule",
        price: "390",
        meta: [
          { label: "Accompagnement", value: "3 séances de conduite" },
          {
            label: "Examen",
            value: "Véhicule mis à disposition le jour de l'examen",
          },
        ],
        note: "Cette formule est pensée pour les candidats qui veulent se concentrer sur l'épreuve pratique taxi. Elle cible la conduite en circulation et la préparation du jour J avec véhicule mis à disposition.",
      },
      {
        name: "Passerelle VTC vers taxi",
        route: "/formation-mobilite-passerelle-vtc-vers-taxi",
        price: "600",
        fee: "+162€ frais examen CMA",
        meta: [
          { label: "Volume", value: "5 jours" },
          { label: "Planning", value: "Disponibilités à convenir" },
        ],
        note: "Cette formule prépare la conversion vers l'activité taxi avec un focus sur la réglementation, la gestion de l'activité et les spécificités du terrain.",
        highlights: ["Véhicule mis à disposition le jour de l'examen"],
      },
      {
        name: "Passerelle taxi vers VTC",
        route: "/formation-mobilite-passerelle-taxi-vers-vtc",
        price: "600",
        fee: "+162€ frais examen CMA",
        meta: [
          { label: "Volume", value: "5 jours" },
          { label: "Planning", value: "Disponibilités à convenir" },
        ],
        note: "Cette passerelle permet de basculer vers l'activité VTC sans repartir sur une formation complète. Vous travaillez les règles, la relation client et les spécificités du métier.",
        highlights: ["Véhicule mis à disposition le jour de l'examen"],
      },
      {
        name: "Formation mobilité taxi 92 / 75",
        route: "/formation-mobilite-taxi-92",
        price: "449",
        meta: [
          { label: "Volume", value: "14h" },
          { label: "Planning", value: "Horaires à convenir" },
        ],
        note: "Cette formation permet d'ajouter Paris (75) et les Hauts-de-Seine (92) à votre carte professionnelle taxi pour élargir votre zone d'activité avec un cadre réglementaire clair.",
      },
    ],
  },
  vtc: {
    itemId: "formation-vtc",
    slug: "vtc",
    title: "Formation VTC: initiale, continue et pratique | Institut Taxi",
    description:
      "Consultez les formations VTC de l'Institut Taxi: initiale, continue, pratique, e-learning et passerelles taxi VTC, avec prix, accompagnement et détail des parcours.",
    listName: "Tarifs des formations VTC",
    serviceType: "Formation VTC",
    offers: [
      {
        name: "Formation VTC initiale journée",
        route: "/formation-vtc-initiale",
        price: "1350",
        fee: "+237€ frais examen CMA",
        meta: [
          { label: "Durée", value: "3 semaines" },
          { label: "Rythme", value: "Lundi au vendredi" },
          { label: "Horaires", value: "9h30 / 16h30" },
        ],
        highlights: [
          "Éligible CPF",
          "Paiement en 3x sans frais",
          "3 séances de conduite",
          "Véhicule mis à disposition le jour de l'examen",
        ],
      },
      {
        name: "Formation VTC initiale soir",
        route: "/formation-vtc-initiale",
        price: "1350",
        fee: "+237€ frais examen CMA",
        meta: [
          { label: "Durée", value: "2 semaines" },
          { label: "Rythme", value: "Lundi au vendredi" },
          { label: "Horaires", value: "18h / 22h" },
        ],
        highlights: [
          "Examen blanc inclus",
          "Éligible CPF",
          "Paiement en 3x sans frais",
          "3 séances de conduite",
          "Véhicule mis à disposition le jour de l'examen",
        ],
      },
      {
        name: "Formation VTC initiale week-end",
        route: "/formation-vtc-initiale",
        price: "1350",
        fee: "+237€ frais examen CMA",
        meta: [
          { label: "Durée", value: "4 week-ends" },
          { label: "Rythme", value: "Samedi et dimanche" },
          { label: "Horaires", value: "9h30 / 16h30" },
        ],
        highlights: [
          "Examen blanc inclus",
          "Éligible CPF",
          "Paiement en 3x sans frais",
          "3 séances de conduite",
          "Véhicule mis à disposition le jour de l'examen",
        ],
      },
      {
        name: "Formation VTC E-learning",
        route: "/formation-vtc-en-ligne",
        price: "549",
        fee: "Frais d'examen inclus",
        meta: [
          { label: "Durée", value: "1 mois" },
          { label: "Support", value: "Application ludo-pédagogique" },
          { label: "Questions", value: "Entre 1 000 et 1 500" },
        ],
        highlights: [
          "Paiement en 4 fois sans frais de 137,25€",
          "QCM, jeux, duels, etc.",
          "Théorie et pratique avec véhicule",
          "Examen blanc inclus",
        ],
      },
      {
        name: "Formation VTC continue 14h",
        route: "/formation-vtc-continue",
        price: "170",
        meta: [
          { label: "Volume", value: "14h / 2 jours" },
          { label: "Planning", value: "Disponibilité à convenir" },
        ],
        note: "Cette formation continue est obligatoire pour les chauffeurs VTC déjà titulaires de la carte professionnelle. Elle se suit tous les 5 ans pour actualiser réglementation, sécurité routière et pratique métier.",
      },
      {
        name: "Formation VTC pratique seule",
        route: "/formation-vtc-pratique-seule",
        price: "390",
        meta: [
          { label: "Accompagnement", value: "3 séances de conduite" },
          {
            label: "Examen",
            value: "Véhicule mis à disposition le jour de l'examen",
          },
        ],
        note: "Cette formule vise l'épreuve pratique T3P uniquement. Elle permet de travailler la conduite en circulation, les manoeuvres utiles et les conditions réelles de l'examen avec véhicule adapté.",
      },
      {
        name: "Passerelle taxi vers VTC",
        route: "/formation-mobilite-passerelle-taxi-vers-vtc",
        price: "600",
        fee: "+162€ frais examen CMA",
        meta: [
          { label: "Volume", value: "5 jours" },
          { label: "Planning", value: "Disponibilités à convenir" },
        ],
        note: "Cette passerelle permet de basculer vers l'activité VTC sans repartir sur une formation complète. Vous travaillez les règles, la relation client et les spécificités du métier.",
        highlights: ["Véhicule mis à disposition le jour de l'examen"],
      },
      {
        name: "Passerelle VTC vers taxi",
        route: "/formation-mobilite-passerelle-vtc-vers-taxi",
        price: "600",
        fee: "+162€ frais examen CMA",
        meta: [
          { label: "Volume", value: "5 jours" },
          { label: "Planning", value: "Disponibilités à convenir" },
        ],
        note: "Cette formule prépare la conversion vers l'activité taxi avec un focus sur la réglementation, la gestion de l'activité et les spécificités du terrain.",
        highlights: ["Véhicule mis à disposition le jour de l'examen"],
      },
    ],
  },
  modulables: {
    itemId: "formations-acceleree-vtc-taxi",
    slug: "modulables",
    title: "Formation modulable taxi et VTC | Institut Taxi",
    description:
      "Découvrez les formations modulables taxi et VTC de l'Institut Taxi: cours du soir, week-end et formule mix, avec prix, CPF, accompagnement et organisation adaptable à votre planning.",
    listName: "Tarifs des formations modulables taxi et VTC",
    serviceType: "Formation modulable taxi et VTC",
    offers: [
      {
        name: "Formation accélérée jour",
        route: "/formation-vtc-initiale",
        price: "1100",
        fee: "+241€ frais d'examen",
        meta: [
          { label: "Durée", value: "1 semaine" },
          { label: "Rythme", value: "Lundi au vendredi" },
          { label: "Horaires", value: "09h30 / 16h30" },
        ],
        highlights: [
          "Théorie et pratique avec véhicule",
          "Total : 1 341 €",
          "Examen blanc inclus",
        ],
      },
      {
        name: "Formation accélérée soir",
        route: "/formation-vtc-initiale",
        price: "1100",
        fee: "+241€ frais d'examen",
        meta: [
          { label: "Durée", value: "1 semaine" },
          { label: "Rythme", value: "Lundi au vendredi" },
          { label: "Horaires", value: "18h00 / 21h30" },
        ],
        highlights: [
          "Théorie et pratique avec véhicule",
          "Total : 1 341 €",
          "Examen blanc inclus",
        ],
      },
      {
        name: "Formation E-learning",
        route: "/formation-vtc-initiale",
        price: "549",
        fee: "Frais d'examen inclus",
        meta: [
          { label: "Durée", value: "1 mois" },
          { label: "Support", value: "Application ludo-pédagogique" },
          { label: "Questions", value: "Entre 1 000 et 1 500" },
        ],
        highlights: [
          "QCM, jeux, duels, etc.",
          "Théorie et pratique avec véhicule",
          "Examen blanc inclus",
        ],
      },
      {
        name: "Formation modulable soir",
        route: "/formation-vtc-initiale",
        price: "1350",
        fee: "+237€ frais examen CMA",
        meta: [
          { label: "Durée", value: "2 semaines" },
          { label: "Rythme", value: "Lundi au vendredi" },
          { label: "Horaires", value: "18h / 22h" },
        ],
        highlights: [
          "Examen blanc inclus",
          "Éligible CPF",
          "Paiement en 3x sans frais",
          "3 séances de conduite",
          "Véhicule mis à disposition le jour de l'examen",
        ],
      },
      {
        name: "Formation modulable week-end",
        route: "/formation-vtc-initiale",
        price: "1350",
        fee: "+237€ frais examen CMA",
        meta: [
          { label: "Durée", value: "4 week-ends" },
          { label: "Rythme", value: "Samedi et dimanche" },
          { label: "Horaires", value: "9h30 / 16h30" },
        ],
        highlights: [
          "Examen blanc inclus",
          "Éligible CPF",
          "Paiement en 3x sans frais",
          "3 séances de conduite",
          "Véhicule mis à disposition le jour de l'examen",
        ],
      },
      {
        name: "Formation modulable mix",
        route: "/contact",
        price: "1350",
        fee: "+237€ frais examen CMA",
        meta: [
          { label: "Format", value: "Parcours personnalisé" },
          { label: "Organisation", value: "Mixez nos formules" },
        ],
        note: "Cette formule permet de composer un parcours soir et week-end adapté à votre planning. Elle convient aux candidats qui ont besoin d'un rythme plus souple ou d'une organisation personnalisée.",
        highlights: [
          "Examen blanc inclus",
          "Éligible CPF",
          "Paiement en 3x sans frais",
          "3 séances de conduite",
          "Véhicule mis à disposition le jour de l'examen",
        ],
      },
    ],
  },
  mobilite: {
    itemId: "carte-pro-vtc-taxi",
    slug: "mobilite",
    title: "Formation mobilité et passerelle taxi VTC | Institut Taxi",
    description:
      "Consultez les formations mobilité, passerelles et e-learning taxi VTC de l'Institut Taxi: mobilité 92/75, conversions professionnelles et parcours en ligne.",
    listName: "Tarifs des formations mobilité et passerelle",
    serviceType: "Formation mobilité et passerelle taxi VTC",
    offers: [
      {
        name: "Formation mobilité taxi 92 / 75",
        route: "/formation-mobilite-taxi-92",
        price: "449",
        meta: [
          { label: "Volume", value: "14h" },
          { label: "Planning", value: "Horaires à convenir" },
        ],
        note: "Cette formation permet d'ajouter Paris (75) et les Hauts-de-Seine (92) à votre carte professionnelle taxi pour élargir votre zone d'activité avec un cadre réglementaire clair.",
      },
      {
        name: "Passerelle taxi vers VTC",
        route: "/formation-mobilite-passerelle-taxi-vers-vtc",
        price: "600",
        fee: "+162€ frais examen CMA",
        meta: [
          { label: "Volume", value: "5 jours" },
          { label: "Planning", value: "Disponibilités à convenir" },
        ],
        note: "Cette passerelle permet de basculer vers l'activité VTC sans repartir sur une formation complète. Vous travaillez les règles, la relation client et les spécificités du métier.",
        highlights: ["Véhicule mis à disposition le jour de l'examen"],
      },
      {
        name: "Passerelle VTC vers taxi",
        route: "/formation-mobilite-passerelle-vtc-vers-taxi",
        price: "600",
        fee: "+162€ frais examen CMA",
        meta: [
          { label: "Volume", value: "5 jours" },
          { label: "Planning", value: "Disponibilités à convenir" },
        ],
        note: "Cette formule prépare la conversion vers l'activité taxi avec un focus sur la réglementation, la gestion de l'activité et les spécificités du terrain.",
        highlights: ["Véhicule mis à disposition le jour de l'examen"],
      },
      {
        name: "Formation Taxi E-learning",
        route: "/formation-taxi-en-ligne",
        price: "549",
        fee: "Frais d'examen inclus",
        meta: [
          { label: "Durée", value: "1 mois" },
          { label: "Support", value: "Application ludo-pédagogique" },
          { label: "Questions", value: "Entre 1 000 et 1 500" },
        ],
        highlights: [
          "Paiement en 4 fois sans frais de 137,25€",
          "QCM, jeux, duels, etc.",
          "Théorie et pratique avec véhicule",
          "Examen blanc inclus",
        ],
      },
      {
        name: "Formation VTC E-learning",
        route: "/formation-vtc-en-ligne",
        price: "549",
        fee: "Frais d'examen inclus",
        meta: [
          { label: "Durée", value: "1 mois" },
          { label: "Support", value: "Application ludo-pédagogique" },
          { label: "Questions", value: "Entre 1 000 et 1 500" },
        ],
        highlights: [
          "Paiement en 4 fois sans frais de 137,25€",
          "QCM, jeux, duels, etc.",
          "Théorie et pratique avec véhicule",
          "Examen blanc inclus",
        ],
      },
    ],
  },
};

export function getServicesSectionSlug(input) {
  if (!input) {
    return null;
  }

  if (Object.prototype.hasOwnProperty.call(sections, input)) {
    return input === "default" ? null : input;
  }

  return itemIdToSection[input] || null;
}

export function getServicesItemIdFromRoute(route) {
  const routeSection = route?.params?.section || route?.query?.itemActif;
  const resolvedSection = getServicesSectionSlug(routeSection);

  if (!resolvedSection) {
    return null;
  }

  return sections[resolvedSection].itemId;
}

export function getServicesRouteLocation(itemIdOrSection) {
  const section = getServicesSectionSlug(itemIdOrSection);

  if (!section) {
    return { name: "services" };
  }

  return {
    name: "services",
    params: { section },
  };
}

function buildCanonical(section) {
  if (!section) {
    return `${SITE_URL}${SERVICES_PATH}`;
  }

  return `${SITE_URL}${SERVICES_PATH}/${section}`;
}

function buildOfferDescription(section, offer) {
  const meta = (offer.meta || []).map(
    (detail) => `${detail.label}: ${detail.value}`
  );
  const highlights = (offer.highlights || []).slice(0, 4);
  const parts = [
    `${offer.name} proposée par l'Institut Taxi.`,
    ...meta,
    offer.fee ? `Frais: ${offer.fee}.` : "",
    offer.note || "",
    ...highlights,
  ].filter(Boolean);

  return `${section.serviceType}. ${parts.join(" ")}`;
}

function buildStructuredData(sectionKey) {
  const section = sections[sectionKey];

  if (!section || !section.offers) {
    return null;
  }

  return {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: section.listName,
    description: section.description,
    itemListOrder: "https://schema.org/ItemListOrderAscending",
    numberOfItems: section.offers.length,
    itemListElement: section.offers.map((offer, index) => ({
      "@type": "ListItem",
      position: index + 1,
      item: {
        "@type": "Service",
        name: offer.name,
        serviceType: section.serviceType,
        provider,
        areaServed: "FR",
        url: `${SITE_URL}${offer.route}`,
        description: buildOfferDescription(section, offer),
        offers: {
          "@type": "Offer",
          priceCurrency: "EUR",
          price: offer.price,
          url: `${SITE_URL}${offer.route}`,
          availability: "https://schema.org/InStock",
        },
      },
    })),
  };
}

export function getServicesSeoData(routeOrSection) {
  const routeSection =
    routeOrSection && typeof routeOrSection === "object"
      ? routeOrSection.params?.section || routeOrSection.query?.itemActif
      : routeOrSection;
  const selectedSection = getServicesSectionSlug(routeSection);
  const resolvedSection = selectedSection || "default";
  const section = sections[resolvedSection];

  return {
    title: section.title,
    description: section.description,
    canonical: buildCanonical(selectedSection),
    jsonLd: buildStructuredData(resolvedSection),
  };
}
